import { create } from 'zustand';

type AuthState = {
  isAuthed: boolean;
  username: string | null;
  setAuthenticated: (username: string | null) => void;
  clearAuth: () => void;
};

const KEY_AUTHED = 'iris_authed';
const KEY_USERNAME = 'iris_username';
const LEGACY_KEY_AUTHED = 'argus_authed';
const LEGACY_KEY_USERNAME = 'argus_username';

function loadString(key: string, legacyKey?: string): string | null {
  try {
    const value = localStorage.getItem(key);
    if (value !== null) return value;
    if (!legacyKey) return null;
    const legacyValue = localStorage.getItem(legacyKey);
    if (legacyValue === null) return null;
    localStorage.setItem(key, legacyValue);
    localStorage.removeItem(legacyKey);
    return legacyValue;
  } catch {
    return null;
  }
}

function saveString(key: string, value: string | null): void {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    // ignore storage failures
  }
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthed: loadString(KEY_AUTHED, LEGACY_KEY_AUTHED) === '1',
  username: loadString(KEY_USERNAME, LEGACY_KEY_USERNAME),
  setAuthenticated: (username) => {
    saveString(KEY_AUTHED, '1');
    if (username) saveString(KEY_USERNAME, username);
    set({ isAuthed: true, username: username ?? null });
  },
  clearAuth: () => {
    saveString(KEY_AUTHED, null);
    saveString(KEY_USERNAME, null);
    set({ isAuthed: false, username: null });
  },
}));
